import { Suspense, lazy } from 'react';
const Loading = <div>Loading....</div>;
const MemberSearchPage = lazy(() => import('../pages/memberSearch/MemberSearchPage'));
const MemberDetailPage = lazy(() => import('../pages/memberSearch/MemberDetailPage'));
const memberSearchRouter = () => {
  return [
    {
      path: 'search',
      element: (
        <Suspense fallback={Loading}>
          <MemberSearchPage />
        </Suspense>
      ),
      
      
    },

    {
      path: 'detail/:memberNumber',
      element: (
        <Suspense fallback={Loading}>
          <MemberDetailPage />
        </Suspense>
      ),
    },
   
  ];
};

export default memberSearchRouter;
